import { useState } from "react";
import { faqs } from "@/mocks/site";
import SectionHeading from "@/pages/home/components/SectionHeading";
import Reveal from "@/components/feature/Reveal";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-3xl mx-auto">
        <SectionHeading
          eyebrow="FAQ"
          title="常见问题"
          desc="关于各分区收录范围与查看方式的常见疑问，先在这里做个说明。"
          align="center"
        />

        <div className="mt-8 md:mt-10 space-y-3">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <Reveal key={item.q} delay={Math.min(index, 5) * 50}>
                <div className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-primary-100/40 transition-colors"
                    >
                      <span className="text-sm md:text-base font-label font-medium text-foreground-900">
                        {item.q}
                      </span>
                      <span className="w-6 h-6 shrink-0 flex items-center justify-center text-primary-700">
                        <i
                          className={isOpen ? "ri-subtract-line text-lg" : "ri-add-line text-lg"}
                          aria-hidden="true"
                        />
                      </span>
                    </button>
                  </h3>
                  <div
                    className={`grid transition-all duration-300 ease-out ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                        {item.a}
                      </p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}